import { render, staticRenderFns } from "./BonusPack.vue?vue&type=template&id=63ef9e0e&scoped=true&"
import script from "./BonusPack.vue?vue&type=script&lang=js&"
export * from "./BonusPack.vue?vue&type=script&lang=js&"
import style0 from "./BonusPack.vue?vue&type=style&index=0&id=63ef9e0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ef9e0e",
  null
  
)

export default component.exports